import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";

const shortcuts = [
  { key: "中文字幕4K", icon: "ri-4k-line", desc: "超清画质 · 细节饱满", accent: true },
  { key: "中文字幕BD", icon: "ri-disc-line", desc: "蓝光压制 · 稳定高码率", accent: false },
  { key: "中文字幕DV", icon: "ri-tv-2-line", desc: "轻量版本 · 流畅播放", accent: false },
  { key: "中文字幕合集", icon: "ri-stack-line", desc: "系列打包 · 一次看懂", accent: false },
];

export default function CategoryShortcuts() {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
      {shortcuts.map((item) => {
        const count = movies.filter((m) => m.version === item.key).length;
        return (
          <Link
            key={item.key}
            to={`/category?v=${encodeURIComponent(item.key)}`}
            className={`group rounded-lg p-4 md:p-5 border transition-colors cursor-pointer ${
              item.accent
                ? "bg-primary-900/50 border-primary-700 hover:border-accent-500"
                : "bg-background-900 border-background-800 hover:border-accent-600"
            }`}
          >
            <div
              className={`w-11 h-11 rounded-md flex items-center justify-center text-xl mb-4 ${
                item.accent
                  ? "bg-accent-500 text-background-950"
                  : "bg-secondary-900/60 text-accent-400"
              }`}
            >
              <i className={item.icon} />
            </div>
            <h3 className="font-heading text-foreground-50 font-semibold text-sm md:text-base mb-1">
              {item.key}
            </h3>
            <p className="text-xs text-foreground-400 font-label mb-3 line-clamp-1">{item.desc}</p>
            <span className="text-xs text-accent-500 font-label">{count} 部资源</span>
          </Link>
        );
      })}
    </div>
  );
}